module.exports = __webpack_public_path__ + "img/snv-minion.60768802.png";